<template>
  <div class="centered">
    <div v-if="sessionState === 'success'">
      Password reset successfully.
      <div>
        <button type="button" v-on:click="cancel()">sign in</button>
      </div>
    </div>
    <div v-else>
      <form id="passwordResetForm" autocomplete="off" onsubmit="return false">
        <h1>Set new password</h1>
        <div>
          <div v-if="pinSent">
            <span>Please check your email ({{ username }}) for your PIN.</span>
          </div>
          <div v-else>
            <div>
              <input v-model="username"
                     :disabled="pinSent"
                     class="login-input"
                     autofocus
                     type="email"
                     placeholder="email address for PIN"
                     size="30"
                     required
                     autocomplete="off"
                     :class="{'valid-email-address-format' : !validEmailAddress}"/>
              <button v-on:click="requestResetPassword()"
                      :disabled="pinSent"
                      type="submit"
                      style="margin-left:2%;">get pin
              </button>
            </div>
          </div>
        </div>
        <div v-if="pinSent" style="width:70%;padding-top:2%;margin:0 auto;">
          <div style="float:left;margin-left:27%;">
            <div>
              <input v-model="pin"
                     class="login-input"
                     style="width:105%;"
                     autofocus
                     placeholder="your PIN"
                     autocomplete="off"/>
            </div>
            <div>
              <input v-model="newPassphrase"
                     id="newPassphrase"
                     class="login-input"
                     style="width:105%;"
                     type="password"
                     placeholder="new password"
                     size="30"
                     required
                     autocomplete="off"/>
            </div>
            <div>
              <input v-model="confirmPassphrase"
                     id="confirmPassphrase"
                     class="login-input"
                     style="width:105%;"
                     type="password"
                     placeholder="confirm new password"
                     size="30"
                     autocomplete="off"/>
            </div>
            <div v-if="passphraseError" class="invalid-indicator">
              <span>{{ passphraseError }}</span>
            </div>
          </div>
          <div style="float:left;width:30%;margin-left:5%;padding-top:1%;">
            <div style="padding-left:5%;text-align:left;background:lightgray;">
              <span style="font-weight:bold;">Passwords must be at least ten characters long, and contain<br/><b>ALL</b> of the following:</span>
              <ul style="margin:0">
                <li>at least one lower case letter</li>
                <li>at least one upper case letter</li>
                <li>at least one number</li>
                <li>at least one punctuation</li>
              </ul>
            </div>
          </div>
        </div>
        <div v-if="pinSent" style="float:left;width:100%;padding:12px 15px;">
          <button type="submit" v-on:click="resetPassword()">reset</button>
        </div>
      </form>
    </div>
    <div v-if="!pinSent" style="float:left;width:100%;padding:24px 15px;">
      <button type="button" v-on:click="cancel()">cancel</button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PasswordResetComponent',
  emits: ['cancel', 'apierror', 'apierrortext'],
  data: function () {
    return {
      sessionState: '',
      username: '',
      newPassphrase: '',
      confirmPassphrase: '',
      passphraseError: false,
      pin: '',
      pinSent: false,
      validEmailAddress: false,
    }
  },
  methods: {
    requestResetPassword: function () {

      this.axios
          .get('email/isValid',
              {
                params: {
                  emailAddress: this.username
                }
              })
          .then(response => {
            this.validEmailAddress = response.data

            if (this.validEmailAddress) {
              this.axios
                  .post('user/requestReset', {
                    userName: this.username,
                    passPhrase: ''
                  })
                  .then(response => {
                    this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.id
                    this.pinSent = true
                    this.userName = ''
                    this.newPassphrase = ''
                  })
                  .catch(error => {
                    this.validEmailAddress = false
                    this.$emit('apierror', true)
                    this.$emit('apierrortext', error.response.statusText)
                  })
            }
          })
          .catch(error => {
            this.validEmailAddress = false
            this.setApiError(true)
            this.setApiErrorText(error.response.statusText)
          })
    },
    resetPassword: function () {
      let passwordsMatch = this.newPassphrase.localeCompare(this.confirmPassphrase)
      if (passwordsMatch !== 0) {
        this.passphraseError = 'Passphrase confirmation does not match.'
        return
      }
      let isLongEnough = this.newPassphrase.length > 9
      if (!isLongEnough) {
        this.passphraseError = 'Password must be at least 10 characters long.'
        return
      }
      let hasLowerAlpha = new RegExp('^(?=.*[a-z])').exec(this.newPassphrase)
      if (hasLowerAlpha == null) {
        this.passphraseError = 'Password must contain a lower case letter.'
        return
      }
      let hasUpperAlpha = new RegExp('^(?=.*[A-Z])').exec(this.newPassphrase)
      if (hasUpperAlpha == null) {
        this.passphraseError = 'Password must contain an upper case letter.'
        return
      }
      let hasNumeric = new RegExp('^(?=.*[0-9])').exec(this.newPassphrase)
      if (hasNumeric == null) {
        this.passphraseError = 'Password must contain a numeric character.'
        return
      }
      let hasSpecialCharacter = new RegExp('\\W', 'g').exec(this.newPassphrase)
      if (hasSpecialCharacter == null) {
        this.passphraseError = 'Password must contain a special character.'
        return
      }

      if (hasLowerAlpha && hasUpperAlpha && hasNumeric && hasSpecialCharacter && isLongEnough) {
        this.axios
            .post('user/resetPassphrase', {
              userName: this.username,
              passPhrase: this.newPassphrase,
              pin: this.pin
            })
            .then(() => {
              this.sessionState = 'success'
            })
            .catch(error => {
              this.$emit('apierror', true)
              this.$emit('apierrortext', error.response.statusText)
              this.sessionState = 'failed'
            })
      }
    },
    reload() {
      this.userName = ''
      this.newPassphrase = ''
      this.confirmPassphrase = ''
      this.sessionState = ''
      this.pin = ''
      this.pinSent = false
      this.validEmailAddress = true
    },
    cancel() {
      this.reload()
      this.$emit('cancel')
    },
  },
  mounted() {
    this.userName = ''
    this.newPassphrase = ''
    this.confirmPassphrase = ''
    this.validEmailAddress = true
  },
}
</script>

<style scoped>
.valid-email-address-format {
  padding: 12px 15px;
  margin: 8px 0;
  width: 20%;
  font-size: 12pt;
  background: #ffdddd;
  border: 1px solid red;
}
</style>
